import React, { PropsWithChildren, useContext } from 'react';
import { BucketLogData } from '@bucketplace/bucket-log';

export interface EditorInfoContextValue {
  /**
   * log 전달시 사용되는 함수
   * e.g. bucketLog({ category: 'click', section: 'button' });
   */
  onSendLog?: (logData: BucketLogData) => void;
  /** 파일을 업로드할 endpoint */
  uploadEndpoint: string;
  /** 초기 로드 시 모든 컨텐츠가 로드되어야 하는지 여부 */
  isInitialLoadAllContent: boolean;
}

const EditorInfoContext = React.createContext<EditorInfoContextValue>({
  uploadEndpoint: '',
  isInitialLoadAllContent: false,
});
export const useEditorInfoContext = () => useContext(EditorInfoContext);

/** 외부에서 주입하는 context 중 여러 Inspector에서 사용되는 context를 관리합니다. */
export function EditorInfoContextProvider({
  children,
  value,
}: PropsWithChildren<{ value: EditorInfoContextValue }>) {
  return (
    <EditorInfoContext.Provider value={value}>{ children }</EditorInfoContext.Provider>
  );
}
